import type { Locale } from '@susu/headless-commerce/config/locale'
import type { CountryConfiguration } from '@susu/headless-commerce/types/CountryConfiguration'
import type { PageType } from '@susu/headless-commerce/types/PageType'
import { trackEvent } from './tracking'

export const trackNavLinkClick = ({
  country,
  isSubMenuLink,
  locale,
  locationId,
  pageType,
  url,
  trackingMenuIdValue,
  trackingParentId,
}: {
  country: CountryConfiguration
  isSubMenuLink: boolean
  locale: Locale
  locationId: string
  pageType: PageType
  url: string
  trackingMenuIdValue?: string
  trackingParentId?: string
}) => {
  trackEvent({
    segment: {
      event: 'menuClicked',
      enrichProps: {
        locale,
        country,
      },
      properties: {
        eventCategory: 'global_interactions',
        eventLabel: null,
        eventLocation: 'menu',
        layer: isSubMenuLink ? 1 : 2,
        locationId,
        menuId: trackingMenuIdValue ?? '',
        parentId: trackingParentId ?? '',
        pageType,
        url,
      },
    },
  })
}
